import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getImpeachmentByUsers, upsertImpeachment, updateImpeachment } from '../services/impeachmentService';

/**
 * Hook personalizado para obtener un impeachment existente entre dos usuarios.
 * Utiliza useQuery de TanStack para manejo de estado asíncrono.
 * Adaptado para web desde amarsi-app.
 */
export const useImpeachmentQuery = (gestorId, demandadoId) => {
  return useQuery({
    queryKey: ['impeachment', gestorId, demandadoId],
    queryFn: () => getImpeachmentByUsers(gestorId, demandadoId),
    enabled: !!gestorId && !!demandadoId,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });
};

/**
 * Hook personalizado para crear o actualizar un impeachment.
 * Utiliza useMutation de TanStack para operaciones de escritura.
 * Adaptado para web desde amarsi-app.
 */
export const useImpeachmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ impeachmentData, existingId }) => {
      console.log('=== DEBUG useImpeachmentMutation ===');
      console.log('existingId:', existingId);
      console.log('impeachmentData:', impeachmentData);
      
      // Corregido: siempre inserta un nuevo registro, no intenta actualizar
      console.log('USANDO upsertImpeachment (siempre nuevo registro)');
      return upsertImpeachment(impeachmentData);
    },
    onSuccess: (data, variables) => {
      console.log('=== useImpeachmentMutation onSuccess ===');
      console.log('Mutación exitosa con datos:', data);
      console.log('Variables usadas:', variables);
      
      // Invalida queries relacionadas para mantener consistencia
      queryClient.invalidateQueries({
        queryKey: ['impeachment', variables.impeachmentData.gestor, variables.impeachmentData.demandado]
      });
    },
    onError: (error, variables) => {
      console.error('=== useImpeachmentMutation onError ===');
      console.error('Error en mutación de impeachment:', error);
      console.error('Variables usadas:', variables);
      console.error('Error completo:', {
        message: error.message,
        code: error.code,
        details: error.details,
        hint: error.hint
      });
    },
  });
};
